<template>
  <div id="chart-scatter">
    <apexchart
      :height="height || 350"
      :options="chartOptions"
      :series="series"
      type="scatter"
      :width="width"/>
  </div>
</template>

<script>
export default {
  name: 'apexChartScatter',
  props: {
    height: [Number, String],
    width: [Number, String],
    chartOptions: {
      type: Object,
      required: true
    },
    series: {
      type: [Object, Array],
      required: true
    },
  }
}
</script>
<style lang="scss">
#chart-scatter {
  width: 100%;
 tspan {
    fill: var(--text-color);
 }
 .apexcharts-menu-item {
    color: black;
 }
}
</style>
